import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import configureStore from './redux';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import Client from 'shopify-buy';

import axios from 'axios';
import { getAccessToken, clearCredentials } from './auth/AuthService'
import { SessionStatus, clearSessionData } from './redux/actions'
import { handleAlertOpen } from './redux/actions/alertActions'

// Add a request interceptor
axios.interceptors.request.use(
    config => {
        const token = getAccessToken();
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    },
    error => {
        Promise.reject(error)
    }
);

const store = configureStore();

// Add a response interceptor: if a protected request comes back 401/403 while
// we still believe we're logged in, our stored credentials are gone or no
// longer accepted. Clear the session and drop to the login page with a notice
// instead of leaving the user staring at a blank, data-less content area.
axios.interceptors.response.use(
    response => response,
    error => {
        const status = error.response && error.response.status;
        const url = (error.config && error.config.url) || '';
        // The login/register endpoints legitimately return 401 for bad
        // credentials — let those flows surface their own errors.
        const isAuthEndpoint = url.includes('rest/auth') || url.includes('rest/register');

        if ((status === 401 || status === 403) && !isAuthEndpoint
                && store.getState().session.sessionStatus === SessionStatus.LOGGED_IN) {
            clearCredentials();
            store.dispatch(clearSessionData());
            store.dispatch(handleAlertOpen({
                title: 'Session expired',
                message: 'You were signed out. Please log in again.',
                severity: 'info'
            }));
        }

        return Promise.reject(error);
    }
);

const client = Client.buildClient({
    storefrontAccessToken: 'a756723c50787179031f4335cd6feda4',
    domain: 'newfangle-llc.myshopify.com'
});
store.dispatch({type: 'CLIENT_CREATED', payload: client});

client.product.fetchAll().then((res) => {
    store.dispatch({type: 'PRODUCTS_FOUND', payload: res});
});
client.checkout.create().then((res) => {
    store.dispatch({type: 'CHECKOUT_FOUND', payload: res});
});
client.shop.fetchInfo().then((res) => {
    store.dispatch({type: 'SHOP_FOUND', payload: res});
});

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter basename={"/"} forceRefresh="true">
                <App/>
            </BrowserRouter>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

serviceWorker.unregister();
